module.exports = __webpack_public_path__ + "img/img_file_thumb02.9c7c4bf3.png";